import { Component, input } from '@angular/core';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-sticker-field-renderer',
  standalone: true,
  imports: [],
  templateUrl: './sticker-field-renderer.component.html',
  styleUrl: './sticker-field-renderer.component.scss'
})
export class StickerFieldRendererComponent {
  control = input.required<ReportControl>();
}
